'use client';

/**
 * @NOTE Our whole internationalization implementation is experimental and will most likely change.
 */
import { Trans, useTranslation } from 'react-i18next';

import { AnyObject } from '@sola/schema/dotcom/helpers.ts';

interface IntlArgs {
  k: string;
  variables?: AnyObject;
}
export const Intl: React.FC<IntlArgs> = ({ k, variables }) => {
  const keyParts = k.split(':');
  const [ns, nsKey] = keyParts.length > 1 ? keyParts : [undefined, k];
  const key = nsKey || k;

  const { t } = useTranslation(ns || undefined);
  if (variables) {
    return t(k, variables) as string;
  }
  // Picking a random valid key to get typescript to chill.
  // @TODO: Implement better.
  return t(k as 'numbers.currency');
};
export const IntlBlock = Trans;
